import styled, { css } from 'styled-components';

import { flexColumn } from '../../../styles/helpers';

const drawerAnimations = css`
  @keyframes slideInDrawer {
    0% {
      left: 100%;
      right: -100%;
    }
    100% {
      left: 0%;
      right: 0%;
    }
  }

  @keyframes slideIOutDrawer {
    0% {
      left: 0%;
      right: 0%;
    }
    100% {
      left: 100%;
      right: -100%;
    }
  }

  &.open-animation {
    animation: 300ms ease-in-out forwards slideInDrawer;
  }
  &.close-animation {
    animation: 300ms ease-in-out forwards slideIOutDrawer;
  }
`;

export const BurgerCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  padding: 6px;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    display: block;
    width: 32px;
    height: 32px;
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
`;

export const Divider = styled.div`
  width: calc(100% - 30px);
  height: 2px;
  padding: 0 15px;
  background: #f2f2f2;
`;

export const Email = styled.a`
  max-width: 100%;
  padding: 0 20px;
  overflow-wrap: anywhere;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
`;

export const Wrapper = styled.div`
  gap: 25px;
  ${flexColumn};
  ${drawerAnimations};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  position: fixed;
  overflow-y: auto;
  background: #fff;
  align-items: center;

  nav:first-child,
  nav:nth-child(5) {
    display: flex;
  }

  header + nav {
    margin-top: 25px;
  }
`;
